export * from "state/school_money/selectors/schools";
export * from "state/school_money/selectors/students";
export * from "state/school_money/selectors/basket";
export * from "state/school_money/selectors/dinners";
export * from "state/school_money/selectors/shop";
export * from "state/school_money/selectors/history";
export * from "state/school_money/selectors/clubs";
export * from "state/school_money/selectors/payments";
export * from "state/school_money/selectors/parental_consent";
export * from "state/school_money/selectors/parents";
export * from "state/school_money/selectors/checkout";
export * from "state/school_money/selectors/secure_trading";

/**
 * @returns {boolean}
 */
export function isActivePaymentsLoading(state) {
  return state.getIn(["school_money", "isActivePaymentsLoading"]);
}

/**
 * @returns {boolean}
 */
export function isGuideOpen(state) {
  return state.getIn(["school_money", "isGuideOpen"]);
}

/**
 * @returns {string}
 */
export function getGuideShownDate(state) {
  return state.getIn(["school_money", "guideShownDate"]);
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/index.js